import React, { ReactNode } from "react";
import {
  HeaderBody,
  HeaderTitle,
  ModalHeader as StyledModalHeader,
} from "../styles";
import { iconResolver } from "../icons/iconResolver";

interface Props {
  title: ReactNode;
  focusRef?: React.RefObject<any>;
  iconName?: "bell" | "bin";
  children?: ReactNode;
}

export const ModalHeader = ({ title, iconName, children, focusRef }: Props) => (
  <StyledModalHeader>
    {iconResolver(iconName)}
    <HeaderTitle ref={focusRef}>{title}</HeaderTitle>
    <HeaderBody>{children}</HeaderBody>
  </StyledModalHeader>
);
